export default __webpack_public_path__ + "static/media/cardBr1.20596a11.png";